import React from "react";
import "./AftersalesCard.css";
import { useTranslation } from "react-i18next";

export default function AftersalesCard({ imageSrc, subtitleKey }) {
  const { t } = useTranslation();

  return (
    <article className="aftersales-card">
      <div className="aftersales-card__media">
        <img
          src={imageSrc}
          alt={t(subtitleKey)}
          className="aftersales-card__img"
        />
      </div>
      <div className="aftersales-card__content">
        <h3 className="aftersales-card__subtitle">{t(subtitleKey)}</h3>
      </div>
    </article>
  );
}